import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  MenuItem,
  DropdownButton,
  Modal,
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton, SearchField } from 'react-bootstrap-table';

class EditBrandHotelContact extends React.Component {
    constructor(props) {
      super(props);
      const emails = [];
      const brandContacts =[];
        this.props.brandContacts.map((contact)=>{
          let check = emails.includes(contact.email);
          if(check==false){
            emails.push(contact.email)
          }
        })
        this.props.brandContacts.map((contact)=>{
          emails.map((email)=>{
            if(email==contact.email){
              let val = {'id':contact.id,'first_name':contact.first_name,'last_name':contact.last_name, 'name':`${contact.first_name} ${contact.last_name}`,'email':contact.email}
              brandContacts.push(val)
            }
          })
          let index = emails.indexOf(contact.email);
          if (index > -1){
            emails.splice(index,1)
          }
        })
      this.state = {
        brandContacts,
        showEdit:false,
        id:null,
        name:null,
        email:null,
        disable:true,
        addcont:false,
        addedcont:true,
        showForm:false,
       }; 
       this.editContact = this.editContact.bind(this);
       this.deleteContact = this.deleteContact.bind(this);
       this.submitContact =this.submitContact.bind(this);
       this.nameChange = this.nameChange.bind(this);
       this.emailChange = this.emailChange.bind(this);
       this.editClose = this.editClose.bind(this);
       this.confirmDelete = this.confirmDelete.bind(this);
       this.deleteClose = this.deleteClose.bind(this);
       this.showAddContact = this.showAddContact.bind(this);
       this.addContact = this.addContact.bind(this);
    }
    editContact(row,rowIndex){
        let name = rowIndex.name;
        let email = rowIndex.email;
        this.setState({
            showEdit:true,
            name:name,
            email:email,
            id:row,
            disable:true,
            showDelete:false,
            delItemId:null,
            delItem:null,
            showForm:false,
            addcont:false,
        })
    }
    nameChange(e){
        this.setState({
            name:e.target.value,
            disable:false,
            addedcont:false,
        })
    }
    emailChange(e){
        this.setState({
            email:e.target.value,
            disable:false,
            addedcont:false,
        })
    }
    editClose(){
        this.setState({
          showEdit:false,
          name:'',
          email:'',
          showForm:false,
          addcont:false,
          })
    }

    submitContact(){
        let proposal = this.props.proposal;
        let id = this.state.id;
        let name = this.state.name;
        let email = this.state.email;
        let payload = {'proposal':proposal.id,'user':id,'name':name,'email':email}
        this.props.HotelBrandContactUpdate(proposal.id,payload,(response)=>{
            const newContact =[];
            const data = this.state.brandContacts;
            data.map((val)=>{
                if(val.id==id){
                    val.name=name;
                    val.email=email;
                }
                newContact.push(val)
            })
            this.setState({
                brandContacts:newContact,
                showEdit:false,
            })

            this.props.updateProposalState(this.state.brandContacts);
        });
    }
    confirmDelete(row,rowIndex){
        this.setState({
            showDelete:true,
            delItemId:row,
            delItem:rowIndex,
            name:'',
            email:'',
        })
    }
    deleteClose(){
        this.setState({
            showDelete:false,
            delItem:null,
            delItem:null,
        })
    }
    deleteContact(){
        const id = this.state.delItemId;
        let proposal = this.props.proposal;
        let brand = proposal.brand;
        let travel_agency = proposal.tour.travel_agency;
        let payload = {'brand':brand.id,'company':travel_agency,'user':id}
        this.props.HotelBrandContactDelete(proposal.id,payload,(response)=>{
            const newContact =[];
            const data = this.state.brandContacts;
            data.map((val)=>{
                if(val.id==id){
                    console.log("contact deleted")
                } else{
                    newContact.push(val);
                }
            })
            this.setState({
                brandContacts:newContact,
                showDelete:false,
            })
            this.props.updateProposalState(this.state.brandContacts);
        })
    }
    showAddContact(){
        this.setState({
            addcont:true,
            showForm:true,
            addedcont:true,
        })
    }
    addContact(){
        let proposal = this.props.proposal;
        const contacts = []
        this.props.proposal.contacts.map((val)=>{
            contacts.push(val.id)
        })
        let tab = this.props.tab;
        let payload ={'contacts':contacts,'name':this.state.name,'email':this.state.email}
        this.props.sendProposal(proposal.id,payload,tab,(response)=>{
            
            const newContact =[];
            const emails =[];

            this.props.brandContacts.map((contact)=>{
              let check = emails.includes(contact.email);
              if(check==false){
                emails.push(contact.email)
              } 
            })

            this.props.brandContacts.map((contact)=>{
              emails.map((email)=>{
                if(email==contact.email){
                  let val = {'id':contact.id,'first_name':contact.first_name,'last_name':contact.last_name,'name':`${contact.first_name} ${contact.last_name}`,'email':contact.email}
                  newContact.push(val)
                }
              })
              let index = emails.indexOf(contact.email);
              if (index > -1){
                emails.splice(index,1)
              }
            })

            this.setState({
                addcont:false,
                showForm:false,
                name:null,
                email:null,
               brandContacts:newContact
            })
        })
    }
    ActionButton =(row,rowIndex) =>{
        return(
            <div>
                <ButtonGroup>
                    <Button onClick={()=>this.editContact(row,rowIndex)}><i className="fa fa-pencil fa-lg"/></Button>
                </ButtonGroup>&nbsp;&nbsp;&nbsp;
                <ButtonGroup>
                    <Button onClick={()=>this.confirmDelete(row,rowIndex)}><i className="fa fa-remove fa-lg"/></Button>
                </ButtonGroup>
            </div>
            )
    }
    render(){
        const options = {
            sortIndicator: false ,
            defaultSortName: 'start',
        };
        return(
            <div>
                <div className="row">
                    <div className="col-md-12">
                      <Modal bsSize="large" show={this.props.showPopUp} onHide={()=>this.props.ContactPopupHide()}>
                        <Modal.Header closeButton>
                          <Modal.Title>Edit brand hotel contacts </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <center>
                          <BootstrapTable
                            containerStyle = {{ marginTop: '10px' }}
                            data = {this.state.brandContacts}
                            options = { options }
                            striped
                          >
                            <TableHeaderColumn dataField="name" dataSort={ true } width="70" headerAlign="center" dataAlign="center"  >Name</TableHeaderColumn>
                            <TableHeaderColumn dataField="email" dataSort={ true } isKey={true} width="80" headerAlign="center" dataAlign="center" >Email</TableHeaderColumn>
                            <TableHeaderColumn dataField="id"  width="40" headerAlign="center" dataAlign="center" dataFormat={this.ActionButton}>Action</TableHeaderColumn>
                          </BootstrapTable>
                          </center><br/><br/>
                          <p>Or invite a new person to respond to your hotel requests.</p>
                          <Button bsStyle="info" onClick={this.showAddContact} disabled={this.state.addcont}>Add Contact</Button>
                          <br/>
                          {this.state.showForm && (<div>
                            <label>name</label>&nbsp;
                            <input
                                className="name request-from-hotel-input-fields"
                                type="text"
                                onChange={this.nameChange}
                                value={this.state.name}
                            />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label>Email</label>&nbsp;
                            <input
                                className="email request-from-hotel-input-fields"
                                type="text"
                                onChange={this.emailChange}
                                value={this.state.email}
                           />&nbsp;&nbsp;
                           <Button bsStyle="info" onClick={this.addContact} disabled={this.state.addedcont}>Add</Button>
                          </div>)}
                        </Modal.Body>
                      </Modal>
                    </div>
                </div>
                {this.state.showEdit &&(
                  <div className="row">
                    <div className="col-md-12">
                      <Modal bsSize="large" show={this.state.showEdit} onHide={()=>this.editClose()}>
                        <Modal.Header closeButton>
                          <Modal.Title>Edit contact</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <center><br/>
                          <label>name</label>&nbsp;&nbsp;
                          <input
                            className="name request-from-hotel-input-fields"
                            type="text"
                            onChange={this.nameChange}
                            value={this.state.name} 
                            />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label>Email</label>&nbsp;&nbsp;
                          <input
                            className="email request-from-hotel-input-fields"
                            type="text"
                            onChange={this.emailChange}
                            value={this.state.email}
                           />&nbsp;&nbsp;
                          </center><br/>
                          <Button bsStyle="info" onClick={this.submitContact} disabled={this.state.disable}>Update</Button>
                          <br/>
                        </Modal.Body>
                      </Modal>
                    </div>
                </div>
                    )}
                {this.state.showDelete &&(
                      <Modal show={this.state.showDelete} onHide={()=>this.deleteClose()}>
                        <Modal.Header closeButton>
                          <Modal.Title>Delete contact</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <center>
                          <h4>Are you sure? you want to delete contact :- {this.state.delItem.email}.</h4>
                          </center>
                          <Button bsStyle="success" onClick={this.deleteContact} >Confirm</Button>&nbsp;&nbsp;
                          <Button bsStyle="info" onClick={this.deleteClose} >Cancel</Button>
                          <br/>
                        </Modal.Body>
                      </Modal>
                    )}
            </div>
            );
    }

}
export default EditBrandHotelContact;


// WEBPACK FOOTER //
// src/routes/tours/components/EditBrandHotelContact.js